import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import CxSalesLocationActions from '../actions/cx-sales-location.actions';
import { CxSalesLocation } from '../../models/sales-location';

export type CxSalesLocationEntity = CxSalesLocation;
export interface CxSalesLocationState extends EntityState<CxSalesLocationEntity> {
  activeEntityId: string;
}

export const entityAdapter = createEntityAdapter<CxSalesLocationEntity>({
  selectId: ({ salesRegionId }) => `${salesRegionId}`,
});

export const initialCxSalesLocationState = entityAdapter.getInitialState({
  activeEntityId: null,
});

export const cxSalesLocationReducer = createReducer(
  initialCxSalesLocationState,

  on(CxSalesLocationActions.selectEntity, (state, { id: activeEntityId }) => {
    return {
      ...state,
      activeEntityId,
    };
  }),

  on(CxSalesLocationActions.updateEntity, (state, { payload }) => entityAdapter.upsertOne(payload, state)),
  on(CxSalesLocationActions.updateEntities, (state, { payload }) => entityAdapter.upsertMany(payload, state)),
);

export function reducer(state: CxSalesLocationState, action: Action) {
  return cxSalesLocationReducer(state, action);
}

export const selectActiveEntityId = (state: CxSalesLocationState) => state.activeEntityId;
export const { selectIds, selectEntities, selectAll, selectTotal } = entityAdapter.getSelectors();
